import type { Link } from '@packages/domain/models/link';
import { normalizeDomain } from 'utils/normalizeDomain/normalizeDomain';

export const normalizePaymentLinks = (links: Link[] = []) =>
  links.map(link => {
    if (
      link.method === 'POST' ||
      (link.method === 'GET' && link.rel === 'sms_notification')
    ) {
      return normalizeDomain(link);
    }

    return link;
  });
